/* @flow */
// $FlowIgnore
import '../css/style.css';
// $FlowIgnore
import '@babel/polyfill';

import React from 'react';
import { BrowserRouter } from 'react-router';
import ReactDOM from 'react-dom/client';
// $FlowIgnore
import { Provider } from 'react-redux';
// $FlowIgnore

import { fetchUser } from 'ducks/auth';
import { fetchApiVersionInfo } from 'ducks/versionInfo';
import { fetchNotifications } from 'ducks/notifications';
import configureRoutes from './routes';
import configureStore from './store';
import { HTML5Backend } from 'react-dnd-html5-backend'
import { DndProvider } from 'react-dnd'

const Root = (): React.Element => {
  const INITIAL_STATE = {};

  const { store } = configureStore(INITIAL_STATE);
  store.dispatch(fetchUser());
  store.dispatch(fetchApiVersionInfo());
  store.dispatch(fetchNotifications());

  return (
    <Provider store={store}>
      <BrowserRouter basename="submission">
        <DndProvider backend={HTML5Backend}>
          {configureRoutes(store)}
        </DndProvider>
      </BrowserRouter>
    </Provider>
  );
};

const rootNode = ReactDOM.createRoot(document.getElementById('gdc-app'));
rootNode.render(<Root />);
